import axios from "axios";
import {CATEGORIES} from "../../constants/axiosURLs";

export function getCategoriesList(thenFunc, catchFunc) {
    axios.get(CATEGORIES, { withCredentials: true })
        .then(thenFunc)
        .catch(catchFunc);
}